import cn from 'classnames';
import { usePlayback } from 'components/Player';
import BasePlaybackButton, {
  PlaybackButtonProps as BasePlaybackButtonProps,
} from 'components/Player/controls/baseControls/PlaybackButton';
import PlayerCondensedControls from 'components/Player/controls/PlayerCondensedControls';
import NewsweekContinueListeningLink from './NewsweekContinueListeningLink';
import styles from './NewsweekWidget.module.scss';

const PlaybackButton = ({ className, ...props }: BasePlaybackButtonProps) => (
  <BasePlaybackButton className={cn(styles.button, className)} {...props} />
);

const NewsweekPlayerControls = () => {
  const { playbackState } = usePlayback();

  return (
    <PlayerCondensedControls
      className={cn(styles.controls, {
        [styles.controls__ended]: playbackState === 'ended',
      })}
      endedContent={<NewsweekContinueListeningLink />}
      endedStrategy="custom"
      icon={PlaybackButton}
      size="md"
    />
  );
};

export default NewsweekPlayerControls;
